setTimeout(() => {
    $('.modal #reason, #reason').each(function () {
        const element = $(this);
        const parentWrapper = element.parent().parent();

        const infoBlockPeriodAvailable = parentWrapper.find('#tip-other-period-available');
        const infoBlockDoubleBooked = parentWrapper.find('#tip-double-booked');
        const infoBlockCalendarNotCurrent = parentWrapper.find('#tip-calendar-not-current');
        const infoBlockIncorrectAudience = parentWrapper.find('#tip-incorrect-audience');
        const infoBlockCancelledByGuest = parentWrapper.find('#cancelled_by_guest');
        const infoBlocks = [
            infoBlockPeriodAvailable,
            infoBlockDoubleBooked,
            infoBlockCalendarNotCurrent,
            infoBlockIncorrectAudience,
            infoBlockCancelledByGuest
        ];

        hideInfoBlocks(infoBlocks);
        switchInfoBlock(element.val());

        element.on('change', function () {
            hideInfoBlocks(infoBlocks);
            switchInfoBlock(element.val(), 500);
        });

        /**
         * Hide all blocks.
         *
         * @param infoBlocks
         */
        function hideInfoBlocks(infoBlocks) {
            infoBlocks.forEach((block) => block.hide());
        }


        function switchInfoBlock(value, speed = null) {
            switch (value) {
                case 'other_converted':
                    infoBlockPeriodAvailable.show(speed);
                    break;
                case 'double_booked':
                    infoBlockDoubleBooked.show(speed);
                    break;
                case 'calendar_not_current':
                    infoBlockCalendarNotCurrent.show(speed);
                    break;
                case 'incorrect_audience':
                    infoBlockIncorrectAudience.show(speed);
                    break;
                case 'cancelled_by_guest':
                    infoBlockCancelledByGuest.show(speed);
                    break;
            }
        }
    });

}, 200);
